<template>
  <div>
    <h1 class="text-center">News</h1>
    <div>
      <List />
    </div>
  </div>
</template>

<script>
import List from "./ListNews.vue";
export default {
  components: {
    List,
  },
};
</script>
